import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 16px;
  border-radius: 12px;
  background: #fdfdfd;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.div`
  margin-bottom: 12px;
  font-weight: bold;
  color: #333;
  font-size: 16px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
`;

export const PlayPauseButton = styled.button`
  font-size: 24px;
  border: none;
  background: #ff69b4;
  color: white;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TimeText = styled.span`
  font-size: 12px;
`;

interface SliderProps {
  progressPercent: number;
}

export const Slider = styled.input.attrs({ type: "range" })<SliderProps>`
  flex: 1;
  appearance: none;
  height: 6px;
  border-radius: 10px;
  outline: none;
  cursor: pointer;
  background: ${({ progressPercent }) =>
    `linear-gradient(to right, #ff69b4 ${progressPercent}%, #ddd ${progressPercent}%)`};
`;
